import { useRef } from 'react'
import { createUseStyles } from 'react-jss'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import ConditionalWrapper from '@/components/ConditionalWrapper'
import Loader from '@/components/Loader'
import Header from '@/components/Header'
import Overlay from '@/components/Overlay'
import Spinner from '@/components/Spinner'
import Nav from '@/components/Nav'
import SVGSprite from '@/components/SVGSprite'
import useFontPreload from '@/hooks/useFontPreload'
import useLenisScroll from '@/hooks/useLenisScroll'
import useChangePathname from '@/hooks/useChangePathname'
import { CONFIG } from '@/constants'
import global from '@/styles/global'

const useStyles = createUseStyles(global)

const Layout = ({ children }) => {
  const $root = useRef()
  const classes = useStyles()
  useFontPreload({ fonts: ['Roobert', 'GTSuperDisplay'] })
  useLenisScroll()
  useChangePathname()

  const handleConditionalWrapper = (child) => (
    <GoogleReCaptchaProvider reCaptchaKey={CONFIG.RECAPTCHA_SITE_KEY}>
      {child}
    </GoogleReCaptchaProvider>
  )

  const renderChildren = () => (
    <>
      <div
        className="wrapper"
        ref={$root}
      >
        {children}
      </div>
      <SVGSprite />
      <Spinner />
      <Nav />
      <Header />
      <Overlay />
      <Loader />
    </>
  )

  return (
    <div className={`${classes.root} content-root`}>
      <ConditionalWrapper
        condition={false}
        wrapper={handleConditionalWrapper}
        child={renderChildren}
      />
    </div>
  )
}

export default Layout
